module.exports = __webpack_public_path__ + "static/img/search.b23af4b4.png";